import axios from 'axios';
import get from 'lodash.get';

export const getPusherConfig = () => {
  return axios.get('/pusher/config').then((response) => {
    return get(response, 'data', null);
  });
};

export const postMessage = ({ channel, eventName, message, clientPusherApps }) => {
  return axios.post('/notifier/send', {
    channel,
    eventName,
    message,
    clientPusherApps,
  });
};

export const batchAuthenticate = (requests) => {
  return axios.post('/pusher/auth/batch', { requests });
};
